<template>
  <div ref="scroller" class="message-list">
    <div v-for="(message, index) in messages" :key="index">
      <McpMessageItem
        v-if="message.role === 'ai' && (message.mcpData || !message.message)"
        :message="message"
        :is-answering="isAnsweringMsg(message, index)"
        :is-loading="isLoadingMsg(message, index)"
      />
      <MessageItem
        v-else
        :message="message"
        :is-answering="isAnsweringMsg(message, index)"
        :is-loading="isLoadingMsg(message, index)"
        :user-data="userData"
      />
    </div>
    <MessageItem
      :message="{ role: 'ai', message: $t('mine.chat.welcomeMessage') }"
      :user-data="userData"
      :disable-parsing="true"
    />
  </div>
</template>

<script>
import MessageItem from './MessageItem.vue'
import McpMessageItem from './McpMessageItem.vue'

export default {
  name: 'MessageList',
  components: {
    MessageItem,
    McpMessageItem
  },
  props: {
    messages: Array,
    isLoading: Boolean,
    isAnswering: Boolean,
    userData: Object
  },
  data () {
    return {
      isAtBottom: true
    }
  },
  mounted () {
    this.checkScroll()
    this.$emit('at-bottom', this.isAtBottom)
    this.$refs.scroller.addEventListener('scroll', this.checkScroll, { passive: true })
  },
  beforeDestroy () {
    this.$refs.scroller.removeEventListener('scroll', this.checkScroll)
  },
  watch: {
    messages: {
      handler () {
        this.$nextTick(this.checkScroll)
      },
      deep: true
    }
  },
  methods: {
    isLoadingMsg (msg, index) {
      return this.isLoading && index === 0 && msg.role === 'ai'
    },
    isAnsweringMsg (msg, index) {
      return this.isAnswering && index === 0 && msg.role === 'ai'
    },
    checkScroll () {
      const scroller = this.$refs.scroller
      if (!scroller) return
      const atBottom = Math.abs(scroller.scrollTop) <= 4
      if (atBottom !== this.isAtBottom) {
        this.isAtBottom = atBottom
        this.$emit('at-bottom', atBottom)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-list {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  max-height: 100%;
  overflow-y: auto;
  padding-top: 10px;
  box-sizing: border-box;

  .toast {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 32px;
    padding: 6px 16px;
    border-radius: 6px;
    background-color: #000;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
    font-size: 13px;
    font-weight: 400;
    line-height: 1.2;
    color: #fff;
    box-sizing: border-box;
    z-index: 10;
  }

  &::-webkit-scrollbar {
    width: 22px;
  }

  &::-webkit-scrollbar-thumb {
    height: 30%;
    background: #C3C3C3;
    border-radius: 16px;
    border: 7px solid #ECECEC;
  }

  &::-webkit-scrollbar-track {
    background: none;
  }
}

</style>
